var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rich-wrapper form-group"},[_c('div',{ref:"editor"})])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/reused-components/rich-text-editor/RichTextEditor.vue